import api, { checkTokenErrorResponse } from '..';

export async function postCoach(email, password, nome, sobrenome, genero, data_nascimento, iso2_ddi = null, ddi = null, telefone = null, logradouro = null, cidade = null, bairro = null, estado = null, cep = null, foto = null) {
    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);

    formdata.append("nome", nome);
    formdata.append("sobrenome", sobrenome);
    formdata.append("genero", genero);
    formdata.append("data_nascimento", data_nascimento);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cep", cep);
    if (foto !== null)
        formdata.append('foto', foto);

    return api.post(`professores/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postLinkCoachClasses(coachId, turmas) {
    return api.post(`professores/${coachId}/vincular_turmas/`, {
        turmas
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteUnlinkCoachClass(coachId, classId) {
    return api.delete(`professores/${coachId}/desvincular_turma/${classId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getCoaches() {
    return api.get(`professores/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getCoachInfos(id) {
    return api.get(`professores/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function disableCoach(id) {
    return api.patch(`professores/${id}/desativar_professor/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function activateCoach(id) {
    return api.patch(`professores/${id}/ativar_professor/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


export async function patchCoach(id, email, password = "", nome, sobrenome, data_nascimento, iso2_ddi = null, ddi = null, telefone = null, logradouro = null, cidade = null, bairro = null, estado = null, cep = null, foto = null) {
    const formdata = new FormData();
    formdata.append("nome", nome);
    formdata.append("sobrenome", sobrenome);
    formdata.append("data_nascimento", data_nascimento);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cep", cep);
    formdata.append("email", email);
    if(password !== "")
        formdata.append("password", password);
    if (foto !== null && typeof foto !== "string")
        formdata.append('foto', foto);

        console.log(cep);
        console.log(ddi);

    return api.patch(`professores/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteCoach(id) {
    return api.delete(`professores/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchCoachPassword(id, password) {
    
    return api.patch(`professores/${id}/`, {password})
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const coachServices = {
    postCoach,
    postLinkCoachClasses,
    deleteUnlinkCoachClass,
    getCoaches,
    getCoachInfos,
    patchCoach,
    deleteCoach,
    disableCoach,
    activateCoach,
    patchCoachPassword,
    // function,
}
export default coachServices;